import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import { BottomNextButton } from "components/common/BottomNextButton";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import coffee_bigger_than from "static/image/onboarding/coffee_bigger_than.png";
import distancing_bigger_than from "static/image/onboarding/distancing_bigger_than.png";
import { useMutation } from "@tanstack/react-query";
import { onboardingApi } from "../../../../api/onboardingApi";
import { userAtom } from "../../../../recoil/userAtom";
import { useRecoilValue } from "recoil";

export default function Habit_7() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  const handleNext = () => {
    navigate(`/onboarding_new/motivation/1`);
  };

  const pageKey = "habit_7";

  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    savePage(pageKey);
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          {"내 삶의 변화를 위한 값진 투자."}
        </CustomTypography>
        {user?.onboardingType !== "l" && (
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {
              "프리미엄 코칭이 제공되는 최상위 마스터 플랜 기준으로도 하루 이용 비용은 4천 원대. 커피 한 잔 가격에 불과합니다."
            }
          </CustomTypography>
        )}
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {user?.onboardingType === "l"
            ? "당신이 디스턴싱에 투자할 100일은 앞으로 살아갈 50년 중 1%도 채 되지 않습니다."
            : "그리고 당신이 디스턴싱에 투자할 100일은 앞으로 살아갈 50년 중 1%도 채 되지 않습니다."}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {"단 1%의 시간으로 남은 99%의 삶을 바꿔보세요."}
        </CustomTypography>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              user?.onboardingType === "l"
                ? distancing_bigger_than
                : coffee_bigger_than
            }
            alt={"onboarding"}
            style={{
              maxHeight: "80%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
